import React from "react";
function AboutSection() {
  return (
   <section className="who-section">

        <h2 className="section-heading">Who Is KaalBet Online?</h2>

        <p className="section-text">
          KaalBet Online has become the safest, most exciting, and most valuable
          legal <span className="highlight">cricket ID provider</span> in India.
          Our platform is built for players who are looking for trustworthiness
          and reliability, openness, and continuous thrill.
        </p>

        <ul className="feature-list">
          <li>A winning environment molded for your triumph</li>
          <li>Connection to a widening network of happy bettors</li>
          <li>Fair play and responsible betting support</li>
          <li>Rely on our open dealings with no hidden terms</li>
        </ul>

        <p className="section-text">
          With reliable customer support and exciting features all under one
          gaming ID, KaalBet Online has become one of the most comprehensive and trustworthy Online Cricket ID platforms in India.
          
        </p>

      </section>
  );
}

export default AboutSection;